import type { SVGProps } from 'react';
const SvgFinecoFunds = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      d="M12 24C5.385 24 0 18.615 0 12C0 7.11 2.925 2.745 7.455 0.885C8.025 0.66 8.685 0.93 8.925 1.5C9.165 2.07 8.88 2.73 8.31 2.97C4.62 4.485 2.25 8.025 2.25 12C2.25 17.37 6.63 21.75 12 21.75C16.02 21.75 19.575 19.335 21.06 15.6C21.285 15.015 21.945 14.73 22.515 14.97C23.085 15.195 23.37 15.855 23.145 16.425C21.315 21.015 16.935 23.985 11.985 23.985L12 24Z"
      fill="#00549F"
    />
    <path
      d="M22.875 13.125H12C11.385 13.125 10.875 12.615 10.875 12V1.125C10.875 0.51 11.385 0 12 0C18.615 0 24 5.385 24 12C24 12.615 23.49 13.125 22.875 13.125ZM13.125 10.875H21.69C21.18 6.39 17.61 2.835 13.125 2.31V10.875Z"
      fill="#00549F"
    />
  </svg>
);
export default SvgFinecoFunds;
